<template>
  <div class="container">
    <md-progress-bar md-mode="query" class="md-accent" v-if="loading"></md-progress-bar>
    
    <div class="md-layout-item md-size-100" v-else>
      <md-table md-card>
        <md-table-toolbar>
          <h1 class="md-title">{{ $t("user.list.title") }}</h1>
        </md-table-toolbar>

        <md-table-row>
          <md-table-head>{{$t('user.list.name')}}</md-table-head>
          <md-table-head>{{$t('user.list.username')}}</md-table-head>
          <md-table-head>{{$t('user.list.email')}}</md-table-head>
          <md-table-head>{{$t("user.list.edit")}}</md-table-head>
        </md-table-row>

        <md-table-row v-for="user in listUsers" :key="user.id">
          <md-table-cell>{{user.firstName}} {{user.lastName}}</md-table-cell>
          <md-table-cell>{{user.userName}}</md-table-cell>
          <md-table-cell>{{user.email}}</md-table-cell>
          <md-table-cell>
              <md-button class="md-info" :to="`/user/edit/${user.id}`">
              {{$t('user.list.edit')}}

              </md-button>
          </md-table-cell>
        </md-table-row>
      </md-table>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import moment from 'moment';

export default {
  computed: {
    ...mapState({
      listUsers: state => state.SecurityModule.listUsers
    })
  },
  data() {
    return {
      loading: true
    }
  },
  mounted() {
    this.$store.dispatch('usersGet')
      .then(() => this.loading = false)
  }
}
</script>